export default "__VITE_ASSET__BJpzsD9m__ 100w";